import axios from 'axios';
import { getAuthorizedConfiguration } from '../helpers/RequestHelper';

export const IS_LOADING_SALES = 'IS_LOADING_SALES';
export const SET_SALES_DATA = 'SET_SALES_DATA';
export const IS_SAVING = 'IS_SAVING';

export const isLoadingSales = (status) => ({
    type: IS_LOADING_SALES,
    status,
});

export const setSalesData = (data) => ({
    type: SET_SALES_DATA,
    data,
});

export const isSaving = (status) => {
    return {
        type: IS_SAVING,
        status
    }
}

export const loadAllSalesDashboard = (filters) => {
    return function (dispatch, getState) {
        dispatch(isLoadingSales(true));
        let user = getState().oidc.user;
        let config = getAuthorizedConfiguration(user);
        let url = `${window.config.serviceManagementBackendUrl}/Sales`;
        let command = {
            Models: filters?.salesModel ?? [],
            Skus: filters?.materialPt ?? [],
            Years: filters?.year ?? [],
            Months: filters?.month ?? [],
            DateFrom: filters?.salesDateRange?.startDate?.format('YYYY-MM-DD') || null,
            DateTo: filters?.salesDateRange?.endDate?.format('YYYY-MM-DD') || null,
            ComparativeDateFrom: filters?.comparativeDateRange?.startDate?.format('YYYY-MM-DD') || null,
            ComparativeDateTo: filters?.comparativeDateRange?.endDate?.format('YYYY-MM-DD') || null,
        };

        return axios
            .post(url, command, config)
            .then((serverResponse) => {
                dispatch(isLoadingSales(false));
                if (serverResponse.status === 200) {
                    dispatch(setSalesData(serverResponse.data));
                }
                return Promise.resolve();
            })
            .catch((error) => {
                dispatch(isLoadingSales(false));
                console.error('Error loading sales dashboard', error);
                const errorMsg = error.response?.data?.message || error.message || 'Unknown error';
                return Promise.reject(new Error(errorMsg));
            });
    };
};

/**
 * Download filtered saless as Excel report
 * @param {object} filters
 * @returns {Promise<Blob>} - Resolves with the Excel file Blob
 */
export const downloadSalesReport = (filters) => {
    return function (dispatch, getState) {
        dispatch(isSaving(true)) // Start saving/loading indicator
        let user = getState().oidc.user
        let config = getAuthorizedConfiguration(user)
        let url = `${window.config.serviceManagementBackendUrl}/Sales/Report`
        let command = {
            Models: filters?.salesModel ?? [],
            Skus: filters?.materialPt ?? [],
            Years: filters?.year ?? [],
            Months: filters?.month ?? [],
            DateFrom: filters?.salesDateRange?.startDate?.format('YYYY-MM-DD') || null,
            DateTo: filters?.salesDateRange?.endDate?.format('YYYY-MM-DD') || null,
            ComparativeDateFrom: filters?.comparativeDateRange?.startDate?.format('YYYY-MM-DD') || null,
            ComparativeDateTo: filters?.comparativeDateRange?.endDate?.format('YYYY-MM-DD') || null,
        }

        // Use 'arraybuffer' for Excel downloads, as in other actions
        const axiosConfig = { ...config, responseType: 'arraybuffer' }

        return axios
            .post(url, command, axiosConfig)
            .then((response) => {
                dispatch(isSaving(false)) // End saving/loading indicator
                return Promise.resolve(response.data) // This is an ArrayBuffer
            })
            .catch(async (error) => {
                dispatch(isSaving(false)) // End saving/loading indicator
                let errorMessage = 'Error downloading Sales report'
                try {
                    if (error.response?.data instanceof ArrayBuffer) {
                        // Try to decode the ArrayBuffer as text
                        const decoder = new TextDecoder('utf-8')
                        const text = decoder.decode(error.response.data)
                        errorMessage = text || errorMessage
                    }
                } catch (e) {
                    // fallback to default error message
                }
                console.error(errorMessage, error)
                return Promise.reject(errorMessage)
            })
    }
}/**
 * Download comparative as Excel report
 * @param {object} filters
 * @returns {Promise<Blob>} - Resolves with the Excel file Blob
 */
export const downloadComparativeReport = (filters) => {
    return function (dispatch, getState) {
        dispatch(isSaving(true)) // Start saving/loading indicator
        let user = getState().oidc.user
        let config = getAuthorizedConfiguration(user)
        let url = `${window.config.serviceManagementBackendUrl}/Sales/ComparativeReport`
        let command = {
            Models: filters?.salesModel ?? [],
            Skus: filters?.materialPt ?? [],
            Years: filters?.year ?? [],
            Months: filters?.month ?? [],
            DateFrom: filters?.salesDateRange?.startDate?.format('YYYY-MM-DD') || null,
            DateTo: filters?.salesDateRange?.endDate?.format('YYYY-MM-DD') || null,
            ComparativeDateFrom: filters?.comparativeDateRange?.startDate?.format('YYYY-MM-DD') || null,
            ComparativeDateTo: filters?.comparativeDateRange?.endDate?.format('YYYY-MM-DD') || null,
        }

        // Use 'arraybuffer' for Excel downloads, as in other actions
        const axiosConfig = { ...config, responseType: 'arraybuffer' }

        return axios
            .post(url, command, axiosConfig)
            .then((response) => {
                dispatch(isSaving(false)) // End saving/loading indicator
                return Promise.resolve(response.data) // This is an ArrayBuffer
            })
            .catch(async (error) => {
                dispatch(isSaving(false)) // End saving/loading indicator
                let errorMessage = 'Error downloading Comparative report'
                try {
                    if (error.response?.data instanceof ArrayBuffer) {
                        // Try to decode the ArrayBuffer as text
                        const decoder = new TextDecoder('utf-8')
                        const text = decoder.decode(error.response.data)
                        errorMessage = text || errorMessage
                    }
                } catch (e) {
                    // fallback to default error message
                }
                console.error(errorMessage, error)
                return Promise.reject(errorMessage)
            })
    }
}